<template lang="pug">
.loading(v-show="isBusy")
  .loading-msg
    b-spinner.spinner
    span.message.align-self-center {{ message }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ローディング表示コンポーネント
 *
 * ローディングの表示/非表示を切り替える
 */
@Component
export default class RelativeLoading extends Vue {
  /** ローディングの表示 */
  @Prop({
    required: true
  })
  isBusy!: boolean;
  /** 表示メッセージ */
  @Prop({
    default: () => {
      return "読込み中...";
    }
  })
  message!: string;
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

.loading {
  display: table;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  opacity: 0.8;
  // ローディング表示中にヘッダーやサイドメニューを触らせたいためz-indexを調整
  // ヘッダー:z-index 1000
  // サイドメニュー：z-index 900
  z-index: 800;

  .loading-msg {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    .spinner {
      width: 40px;
      height: 40px;
      margin-right: 12px;
      color: $loading;
    }

    .message {
      @include bold-font(22px);
    }
  }
}
</style>
